module.exports = __webpack_public_path__ + "static/img/2_platform@2x.4e51482.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/2_platform@2x.png
// module id = 7ZWb
// module chunks = 8